import { useCallback } from 'react';
import { RootState, useAppDispatch, useAppSelector } from '../store';
import { addStoredMessage } from '../Store/features/chat/chatSlice';
export const useStoreInputMessage = () => {
    const storedMessagesFromStore = useAppSelector((state: RootState) => state.chats.storedMessages);
    const dispatch = useAppDispatch();

    const storeInputMessage = useCallback(
        (chatId: string, message: string, images?: any[], files?: any[]) => {
            dispatch(addStoredMessage({ chatId, message, images, files }));
        },
        [dispatch],
    );

    const getStoredInputMessage = useCallback(
        (chatId: string) => {
            const storedMessage = storedMessagesFromStore.find((msg) => msg.chatId === chatId);
            return storedMessage ? storedMessage.message : '';
        },
        [storedMessagesFromStore],
    );

    const getStoredInputData = useCallback(
        (chatId: string) => {
            const storedMessage = storedMessagesFromStore.find((msg) => msg.chatId === chatId);
            return storedMessage
                ? {
                      message: storedMessage.message,
                      images: storedMessage.images || [],
                      files: storedMessage.files || [],
                  }
                : { message: '', images: [], files: [] };
        },
        [storedMessagesFromStore],
    );

    return {
        storeInputMessage,
        getStoredInputMessage,
        getStoredInputData,
    };
};
